import { useState } from 'react'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { useEnhancedBrandStore } from '../../stores/enhancedBrandStore'

export function RefreshButton() {
  const { clearAllFilters, isLoading } = useEnhancedBrandStore()
  const [isResetting, setIsResetting] = useState(false)

  const handleReset = async () => {
    setIsResetting(true)
    try {
      clearAllFilters()
    } finally {
      setIsResetting(false)
    }
  }

  return (
    <button
      onClick={handleReset}
      disabled={isLoading || isResetting}
      className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
        isLoading || isResetting
          ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 cursor-not-allowed'
          : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow'
      }`}
      title="Reset all filters"
    >
      <ArrowPathIcon 
        className={`h-4 w-4 ${(isLoading || isResetting) ? 'animate-spin' : ''}`} 
      />
      <span className="hidden sm:inline">
        {isLoading || isResetting ? 'Resetting...' : 'Reset'}
      </span>
    </button>
  )
}